export default __webpack_public_path__ + "static/media/bnr-img.7c07a708.svg";